var render = function render(){
  var _vm$$route$hash;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "start"
  }, [(_vm$$route$hash = _vm.$route.hash) !== null && _vm$$route$hash !== void 0 && _vm$$route$hash.startsWith('#demo:') ? _c('send-sample-dialog', {
    attrs: {
      "sample-id": "64c9dff3-2ac5-47a3-ac87-a52d560fb76f",
      "hash-prefix": _vm.$route.hash.split(':')[0]
    }
  }) : _vm._e(), _c('start-header', {
    attrs: {
      "media": {
        id: '24acb33c-73b9-4115-afdb-8855cce1c126',
        alt: 'Gift cards',
        video: true
      },
      "bg": {
        src: 'https://cdn.ellacard.com/media/61ce9982-fda2-4358-a0e6-0c55e55cf523/lg.webp',
        color: '#d4c9b1'
      },
      "to": {
        name: 'catalog-gift-cards'
      }
    },
    scopedSlots: _vm._u([{
      key: "h1",
      fn: function () {
        return [_vm._v("Gift cards from thousands of international merchants")];
      },
      proxy: true
    }])
  }), _c('start-layer', {
    attrs: {
      "clip-waves-class": "light-gradient",
      "offset": .75
    }
  }, [_c('div', {
    staticClass: "actions"
  }, [_c('v-btn', {
    staticClass: "btn-pop",
    attrs: {
      "x-large": "",
      "rounded": "",
      "dark": "",
      "color": "ec-blue",
      "to": {
        name: 'catalog-gift-cards'
      }
    }
  }, [_vm._v("Send a gift card "), _c('v-icon', {
    staticClass: "mr-n1",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1), _c('v-btn', {
    staticClass: "btn-pop",
    attrs: {
      "x-large": "",
      "rounded": "",
      "dark": "",
      "color": "pink",
      "to": {
        hash: '#demo:sign'
      }
    }
  }, [_vm._v("Try demo…")])], 1), _c('div', {
    staticClass: "grid-alternate"
  }, [_c('div', {
    staticClass: "relative hover-pop-group",
    staticStyle: {
      "aspect-ratio": "8 / 7"
    }
  }, [_c('web-media', {
    staticClass: "absolute r3 white",
    staticStyle: {
      "width": "46%",
      "top": "0",
      "right": "5%"
    },
    attrs: {
      "aspect-ratio": "5 / 7",
      "id": "a79d0593-dcdd-40cd-9899-e398be72035f",
      "alt": "Example card page with group gift card"
    }
  }), _c('img', {
    staticClass: "absolute d-block rn3 white",
    staticStyle: {
      "width": "46%",
      "top": "0",
      "left": "5%"
    },
    attrs: {
      "aspect-ratio": "5 / 7",
      "type": "image/webp",
      "loading": "lazy",
      "src": "https://ellacard-public.s3.amazonaws.com/r/2fff1d48-02e7-4299-98ad-28e7c05d5113",
      "alt": "Example card cover"
    }
  }), _c('web-media', {
    staticClass: "absolute has-alpha rn3",
    staticStyle: {
      "width": "28%",
      "bottom": "6%",
      "left": "0"
    },
    attrs: {
      "aspect-ratio": "1",
      "id": "63609de6-95da-4c9e-900a-444fba1fae27",
      "alt": "Contributor headshot"
    }
  }), _c('v-btn', {
    staticStyle: {
      "width": "90px",
      "bottom": "0",
      "left": "calc(14% - 45px)"
    },
    attrs: {
      "absolute": "",
      "large": "",
      "rounded": "",
      "dark": "",
      "color": "green lighten-2"
    }
  }, [_vm._v("$50")]), _c('web-media', {
    staticClass: "absolute has-alpha rn3",
    staticStyle: {
      "width": "28%",
      "bottom": "2%",
      "left": "36%"
    },
    attrs: {
      "aspect-ratio": "1",
      "id": "ca2c0da0-b561-4d1d-b5e8-4dd1afac766d",
      "alt": "Contributor headshot"
    }
  }), _c('v-btn', {
    staticStyle: {
      "width": "90px",
      "bottom": "-4%",
      "left": "calc(50% - 45px)"
    },
    attrs: {
      "absolute": "",
      "large": "",
      "rounded": "",
      "dark": "",
      "color": "green lighten-2"
    }
  }, [_vm._v("$100")]), _c('web-media', {
    staticClass: "absolute has-alpha rn3",
    staticStyle: {
      "width": "28%",
      "bottom": "6%",
      "left": "72%"
    },
    attrs: {
      "aspect-ratio": "1",
      "id": "b8b5faa5-fa27-4902-92e6-58d0350a0872",
      "alt": "Contributor headshot"
    }
  }), _c('v-btn', {
    staticStyle: {
      "width": "90px",
      "bottom": "0",
      "right": "calc(14% - 45px)"
    },
    attrs: {
      "absolute": "",
      "large": "",
      "rounded": "",
      "dark": "",
      "color": "green lighten-2"
    }
  }, [_vm._v("$100")])], 1), _c('div', [_c('h4', {
    staticClass: "mb-3"
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiAccountGroup)
    }
  }), _vm._v(" Group gift cards")], 1), _c('div', [_vm._v(" Groups can add value idependently to a single gift card – no one has to deal with getting paid back. Make contributions private to let your group donate what they're comfortable with. ")])]), _c('v-lazy', {
    staticStyle: {
      "aspect-ratio": "4 / 3"
    }
  }, [_c('div', {
    staticClass: "relative hover-pop-group",
    staticStyle: {
      "aspect-ratio": "4 / 3"
    }
  }, [_c('web-media', {
    staticClass: "absolute hover-pop has-alpha rn3",
    staticStyle: {
      "aspect-ratio": "144 / 171",
      "width": "30%",
      "left": "0",
      "top": "2%"
    },
    attrs: {
      "id": "d112328a-fdd3-4b53-963f-0271b45358e8",
      "alt": "Example gift card thank you text message to Luke"
    }
  }), _c('web-media', {
    staticClass: "absolute hover-pop has-alpha r1",
    staticStyle: {
      "aspect-ratio": "144 / 171",
      "width": "30%",
      "left": "23.3%",
      "top": "0"
    },
    attrs: {
      "id": "2922c5d6-62dd-4a71-b1a1-fac84ec53e6b",
      "alt": "Example gift card thank you text message to Jessie"
    }
  }), _c('web-media', {
    staticClass: "absolute hover-pop has-alpha rn2",
    staticStyle: {
      "aspect-ratio": "144 / 171",
      "width": "30%",
      "left": "46.7%",
      "top": "2%"
    },
    attrs: {
      "id": "fc3f2211-06c3-4365-a3e7-eb8b12b694ec",
      "alt": "Example gift card thank you text message to Teresa"
    }
  }), _c('div', {
    staticClass: "absolute hover-pop r5 pa-2 grey lighten-4",
    staticStyle: {
      "width": "30%",
      "left": "70%",
      "top": "0"
    }
  }, [_c('web-media', {
    staticClass: "elevation-1",
    staticStyle: {
      "aspect-ratio": "128 / 168"
    },
    attrs: {
      "id": "a4bc8618-9d28-4f22-942b-6153f28cc14c",
      "alt": "Example gift card thank you email to Andrew"
    }
  })], 1), _c('web-media', {
    staticClass: "absolute white hover-pop r5",
    staticStyle: {
      "aspect-ratio": "5 / 7",
      "width": "36%",
      "left": "57%",
      "bottom": "0"
    },
    attrs: {
      "id": "ff6b8278-5731-4284-9b0e-6b3b2a7550e6",
      "alt": "Example gift card thank you page 3"
    }
  }), _c('web-media', {
    staticClass: "absolute white hover-pop",
    staticStyle: {
      "aspect-ratio": "5 / 7",
      "width": "36%",
      "left": "32%",
      "bottom": "0"
    },
    attrs: {
      "id": "0f042492-29dd-441d-a86d-c90768618526",
      "alt": "Example gift card thank you page 2"
    }
  }), _c('web-media', {
    staticClass: "absolute white hover-pop rn5",
    staticStyle: {
      "aspect-ratio": "5 / 7",
      "width": "36%",
      "left": "7%",
      "bottom": "0"
    },
    attrs: {
      "id": "731c8c24-2186-4b99-9ea2-d27740545bb8",
      "alt": "Example gift card thank you page 1"
    }
  })], 1)]), _c('div', [_c('h4', {
    staticClass: "mb-3"
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.iconPathTextEmail)
    }
  }), _vm._v(" Multiple recipients")], 1), _c('div', [_vm._v(" Send gift cards to multiple recipients via text or email – the easiest way to say \"thank you\" to a group all at once. ")])]), _c('web-media', {
    staticClass: "hover-pop rounded-xl white",
    attrs: {
      "aspect-ratio": "16 / 9",
      "id": "4c484036-9f33-4725-b6c1-0509f97a02ef",
      "alt": "Automation",
      "is-video": ""
    }
  }), _c('div', [_c('h4', {
    staticClass: "mb-3"
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiCalendar)
    }
  }), _vm._v(" Bulk scheduling automation")], 1), _c('div', [_vm._v(" Schedule gift cards to send to multiple recipients on different dates – perfect for automating rewards for employee birthdays or work anniversaries. ")])]), _c('div', {
    staticClass: "relative hover-pop-group",
    staticStyle: {
      "aspect-ratio": "4 / 3"
    }
  }, [_c('web-media', {
    staticClass: "absolute rounded-xl white",
    staticStyle: {
      "width": "96%",
      "top": "15%",
      "left": "0"
    },
    attrs: {
      "aspect-ratio": "16 / 9",
      "id": "24acb33c-73b9-4115-afdb-8855cce1c126",
      "alt": "Gift cards for thousands of international merchants",
      "is-video": ""
    }
  }), _c('web-media', {
    staticClass: "absolute rounded r2 white",
    staticStyle: {
      "top": "0",
      "right": "0",
      "width": "30%"
    },
    attrs: {
      "aspect-ratio": "144 / 362",
      "id": "6e32527b-7257-450e-8bc1-604e30897c8d",
      "alt": "Gift card country list"
    }
  })], 1), _c('div', [_c('h4', {
    staticClass: "mb-3"
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiCardMultiple)
    }
  }), _vm._v(" Thousands of merchants")], 1), _c('div', [_vm._v(" Ellacard carries gift cards from top merchants like "), _c('router-link', {
    attrs: {
      "to": {
        name: 'catalog-gift-cards',
        params: {
          providerId: 'RU:AMZ-US'
        }
      }
    }
  }, [_vm._v("Amazon")]), _vm._v(", "), _c('router-link', {
    attrs: {
      "to": {
        name: 'catalog-gift-cards',
        params: {
          providerId: 'TR:DC82VBYLI4CC'
        }
      }
    }
  }, [_vm._v("Apple")]), _vm._v(", "), _c('router-link', {
    attrs: {
      "to": {
        name: 'catalog-gift-cards',
        params: {
          providerId: 'RU:SBUX-US'
        }
      }
    }
  }, [_vm._v("Starbucks")]), _vm._v(", "), _c('router-link', {
    attrs: {
      "to": {
        name: 'catalog-gift-cards',
        params: {
          providerId: 'RU:DDASH-US'
        }
      }
    }
  }, [_vm._v("Doordash")]), _vm._v(", and more in countries / currencies around the world. Or let the "), _c('router-link', {
    attrs: {
      "to": {
        name: 'catalog-gift-cards',
        params: {
          providerId: 'TR:ANY-USD'
        }
      }
    }
  }, [_vm._v("recipient choose")]), _vm._v(". ")], 1)]), _c('web-media', {
    staticClass: "hover-pop rounded-xl white",
    attrs: {
      "aspect-ratio": "4 / 3",
      "id": "2a4bba3d-c1c9-4426-84b3-deb3804ff154",
      "alt": "Example gift card opening experience",
      "is-video": ""
    }
  }), _c('div', [_c('h4', {
    staticClass: "mb-3"
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiGift)
    }
  }), _vm._v(" Perfect presentation")], 1), _c('div', [_vm._v(" Your gift card comes wrapped inside an Ellacard, complete with whatever custom effects you want for the best recipient experience. ")])])], 1), _c('div', {
    staticClass: "actions"
  }, [_c('v-btn', {
    staticClass: "btn-pop",
    attrs: {
      "x-large": "",
      "rounded": "",
      "dark": "",
      "color": "ec-blue",
      "to": {
        name: 'catalog-gift-cards'
      }
    }
  }, [_vm._v("Send a gift card "), _c('v-icon', {
    staticClass: "mr-n1",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1), _c('v-btn', {
    staticClass: "btn-pop",
    attrs: {
      "x-large": "",
      "rounded": "",
      "dark": "",
      "color": "pink",
      "to": {
        hash: '#demo:sign'
      }
    }
  }, [_vm._v("Try demo…")])], 1)]), _c('start-layer', {
    attrs: {
      "clip-waves-class": "dark-gradient",
      "offset": .9
    }
  }, [_c('h2', [_vm._v("Getting started")]), _c('div', {
    staticClass: "grid-alternate"
  }, [_c('div', {
    staticClass: "relative hover-pop-group",
    staticStyle: {
      "aspect-ratio": "4 / 3"
    }
  }, [_c('web-media', {
    staticClass: "white absolute rounded rn3",
    staticStyle: {
      "width": "70%",
      "top": "0",
      "left": "0"
    },
    attrs: {
      "aspect-ratio": "640 / 606",
      "id": "64cb0041-0dd8-4f35-b757-869df3ef545e",
      "alt": "Gift card catalog"
    }
  }), _c('web-media', {
    staticClass: "white absolute rounded",
    staticStyle: {
      "width": "80%",
      "bottom": "0",
      "right": "0"
    },
    attrs: {
      "aspect-ratio": "16 / 9",
      "id": "bdd30b81-701c-43b4-95a9-45b81d0b82fe",
      "alt": "Add gift card button"
    }
  })], 1), _c('div', [_vm._v(" Choose a gift card from our "), _c('router-link', {
    staticClass: "white--text",
    attrs: {
      "to": {
        name: 'catalog-gift-cards'
      }
    }
  }, [_vm._v("gift card catalog")]), _vm._v(", or start with a "), _c('router-link', {
    staticClass: "white--text",
    attrs: {
      "to": {
        name: 'catalog'
      }
    }
  }, [_vm._v("greeting card design")]), _vm._v(" and use the "), _c('div', {
    staticClass: "relative d-inline-block",
    staticStyle: {
      "width": "32px"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "left": "0",
      "top": "calc(50% - 16px)"
    },
    attrs: {
      "absolute": "",
      "x-small": "",
      "fab": "",
      "dark": "",
      "color": "green lighten-2"
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiWalletGiftcard)
    }
  })], 1), _vm._v(" ")], 1), _vm._v(" button to add a gift card when customizing it. ")], 1), _c('web-media', {
    staticClass: "white d-block hover-pop rounded",
    attrs: {
      "aspect-ratio": "1432 / 652",
      "id": "b336db73-bd89-40f8-8803-71b80088653d",
      "alt": "Bulk scheduling automation with Ellacard contacts",
      "title": "Batch order tool",
      "to": {
        name: 'batch-order'
      }
    }
  }), _c('div', [_vm._v(" To schedule gift cards to send to multiple recipients on different dates, use our "), _c('router-link', {
    staticClass: "white--text",
    attrs: {
      "to": {
        name: 'batch-order'
      }
    }
  }, [_vm._v("bulk-scheduling tool")]), _vm._v(". ")], 1)], 1)]), _c('start-reviews', {
    attrs: {
      "tag": "GI"
    }
  }), _c('start-footer')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }